
export default function User(){
	let meta = document.querySelector("meta[name = 'user']").getAttribute('content');

	return JSON.parse(meta);
}



// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/helpers/user.js